// eslint-disable-next-line import/prefer-default-export
export const ACCESS_TOKEN = 'accessToken';
